export const EMAIL_STATUSES = ["Draft", "Approved", "Scheduled", "Sent", "Replied", "Bounced", "Stopped", "Failed"];
export const REPLY_STATUSES = ["None", "Positive", "Not now", "Unsubscribed", "Negative", "Out of office", "Needs review"];
export const DNC_REASONS = ["Unsubscribed", "Negative", "Excluded", "Existing client", "Competitor", "Bounced"];
export const CONSENT_BASIS = "Implied – conspicuously published business address";

export const EMAIL_STATUS_STYLES = {
  Draft: "text-slate-300 border-slate-600 bg-slate-700/30",
  Approved: "text-sky-300 border-sky-500/40 bg-sky-500/10",
  Scheduled: "text-amber-300 border-amber-500/40 bg-amber-500/10",
  Sent: "text-emerald-300 border-emerald-500/40 bg-emerald-500/10",
  Replied: "text-violet-300 border-violet-500/40 bg-violet-500/10",
  Stopped: "text-slate-400 border-slate-700 bg-slate-800/40",
  Failed: "text-red-300 border-red-500/40 bg-red-500/10",
  Bounced: "text-orange-300 border-orange-500/40 bg-orange-500/10",
};

export const BlockedLabel = ({ reason, testid }) =>
  reason ? (
    <span data-testid={testid} className="text-[11px] px-2 py-0.5 rounded-md border border-red-500/40 bg-red-500/10 text-red-300">
      Blocked: {reason}
    </span>
  ) : null;

export const fmtDT = (s) =>
  s ? new Date(s).toLocaleString("en-CA", { timeZone: "America/Toronto", dateStyle: "medium", timeStyle: "short" }) : "—";

export const inputCls =
  "w-full bg-[#0B1120] border border-slate-700 rounded-lg px-3 py-2 text-sm text-white focus:outline-none focus:ring-2 focus:ring-amber-500";
